import {combineReducers, configureStore} from "@reduxjs/toolkit";
import authReducer from "./reducers/auth.reducer";
import {persistReducer, persistStore} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
	key: "root",
	storage: storage,
}

const rootReducer = combineReducers({
	auth: authReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
	reducer: persistedReducer,
	middleware: getDefaultMiddleware => getDefaultMiddleware({
		serializableCheck: false
	})
});

export const persistor = persistStore(store);

export default store;